module.exports = __webpack_public_path__ + "static/media/level4.6fadc59a.svg";